import { render, staticRenderFns } from "./VipDiscountPage.vue?vue&type=template&id=0bd0d6ec"
import script from "./VipDiscountPage.vue?vue&type=script&lang=js"
export * from "./VipDiscountPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports